const useWindowLocation = () => {
  return window.location;
}

export default useWindowLocation;